import { staticText, type Translated } from 'utils/staticText';

export const DateRangePickerStaticText = staticText({
  placeholder: {
    _: 'Select dates',
    zh: '選擇日期',
  },
  done: {
    _: 'Done',
    zh: '完成',
  },
  confirmReturnDate: {
    _: 'Confirm return date',
    zh: '確認回程日期',
  },
  confirmDepartureDate: {
    _: 'Confirm departure date',
    zh: '確認出發日期',
  },
  guidanceStart: {
    _: 'Pick your trip start date.',
    zh: '選擇你的旅程開始日期。',
  },
  guidanceEnd: {
    _: 'Now pick your return date.',
    zh: '選擇你的回程日期。',
  },
  guidanceAnnual: {
    _: 'Pick your start date — annual cover runs a full year, so we set the end date for you.',
    zh: '選擇你的開始日期 — 全年保障涵蓋一整年，結束日期將由我們為你設定。',
  },
  footerEmpty: {
    _: 'Select travel dates',
    zh: '選擇你的旅遊日期',
  },
  footerPickReturn: {
    _: '· pick your return date',
    zh: '· 選擇回程日期',
  },
  footerLocalTime: {
    _: 'All dates are in local time',
    zh: '所有日期均以當地時間為準',
  },
  footerDayCountOne: {
    _: '({count} day{suffix})',
    zh: '（共{count}天{suffix}）',
  },
  footerDayCountOther: {
    _: '({count} days{suffix})',
    zh: '（共{count}天{suffix}）',
  },
  footerAnnualSuffix: {
    _: ' · annual cover',
    zh: ' · 全年保障',
  },
  reasonPast: {
    _: "Trips can't start before today.",
    zh: '行程不可早於今天開始。',
  },
  reasonAdvanceWindow: {
    _: 'Purchase up to {count} days in advance.',
    zh: '最早可提前{count}天投保。',
  },
  reasonBeforeStart: {
    _: 'Your return date must be on or after your start date.',
    zh: '您的回程日期必須在您的起程日期當天或之後。',
  },
  reasonMaxDuration: {
    _: 'Single trips can last up to {count} days.',
    zh: '單次行程最長 {count} 天。',
  },
  // Prefix / suffix of the day button's screen-reader label, mirroring
  // react-day-picker's default "Today, <date>" / "<date>, selected".
  dayLabelToday: {
    _: 'Today',
    zh: '今天',
  },
  dayLabelSelected: {
    _: 'selected',
    zh: '已選擇',
  },
  previousMonthLabel: {
    _: 'Previous month',
    zh: '上個月',
  },
  nextMonthLabel: {
    _: 'Next month',
    zh: '下個月',
  },
  monthNames: {
    _: 'January|February|March|April|May|June|July|August|September|October|November|December',
    zh: '1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月',
  },
  weekdayNames: {
    _: 'S|M|T|W|T|F|S',
    zh: '日|一|二|三|四|五|六',
  },
  // The mobile sheet spans the full width with a single weekday bar, so it has
  // room for the abbreviated names the desktop's side-by-side months don't.
  weekdayNamesShort: {
    _: 'Sun|Mon|Tue|Wed|Thu|Fri|Sat',
    zh: '日|一|二|三|四|五|六',
  },
  sheetTitle: {
    _: 'Select Dates',
    zh: '選擇日期',
  },
  sheetClose: {
    _: 'Close',
    zh: '關閉',
  },
  sheetStartDateLabel: {
    _: 'Start date',
    zh: '起程日期',
  },
  sheetReturnDateLabel: {
    _: 'Return date',
    zh: '回程日期',
  },
  sheetEndDateLabel: {
    _: 'End date',
    zh: '結束日期',
  },
  sheetEmptyDate: {
    _: '—',
    zh: '—',
  },
});

export type DateRangePickerStaticTextType = Translated<
  typeof DateRangePickerStaticText
>;
